function CartIconDark() {
  return (
    <svg className='hidden dark:block' width='24' height='24' viewBox='0 0 32 29' fill='none'>
      <path
        d='M8.9497 4H31L28 14.5H10.5651M29.5 20.5H11.5L8.5 1H4M4 8.5H1M5.5 13H1M7 17.5H1M13 26.5C13 27.3284 12.3284 28 11.5 28C10.6716 28 10 27.3284 10 26.5C10 25.6715 10.6716 25 11.5 25C12.3284 25 13 25.6715 13 26.5ZM29.5 26.5C29.5 27.3284 28.8284 28 28 28C27.1716 28 26.5 27.3284 26.5 26.5C26.5 25.6715 27.1716 25 28 25C28.8284 25 29.5 25.6715 29.5 26.5Z'
        stroke='#fff'
        strokeWidth='1.984'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export default CartIconDark;
